import { html } from 'lit';
const Broom =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M20.777 3.723a.76.76 0 0 1 0 1.075l-6.968 6.968a5.09 5.09 0 0 1 .068 5.946l-2.881 4.1a.663.663 0 0 1-.92.164 29.9 29.9 0 0 1-7.552-7.552.663.663 0 0 1 .164-.92l4.1-2.88a5.09 5.09 0 0 1 5.946.067l6.968-6.968a.76.76 0 0 1 1.075 0M10.25 20.23l2.384-3.393.027-.04c-1.023-.4-2.056-1.083-2.965-1.993-.91-.91-1.592-1.942-1.993-2.965l-.04.027-3.393 2.384a28.3 28.3 0 0 0 5.98 5.98m-1.137-8.962c.313.808.87 1.674 1.658 2.461.787.788 1.653 1.345 2.46 1.658a3.567 3.567 0 0 0-4.118-4.119" clip-rule="evenodd"/>
  </svg>
`;
export default Broom;
